import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { scrollToSection } from "@/lib/scroll";

export default function Footer() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <footer
      data-testid="footer"
      ref={ref}
      className="bg-pragti-dark text-pragti-bg py-20 sm:py-28 px-6 sm:px-8"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7 }}
            className="lg:col-span-8"
          >
            <button
              type="button"
              data-testid="footer-logo"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="font-heading text-6xl sm:text-7xl lg:text-8xl font-bold tracking-tight text-pragti-bg/90 hover:text-pragti-bg transition-colors duration-300"
            >
              pragti.
            </button>
            <p className="font-body text-sm text-pragti-bg/40 mt-6 max-w-md leading-relaxed">
              A digital twin for work and life.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-4 flex flex-col gap-4"
          >
            <button
              type="button"
              data-testid="footer-scroll-top"
              onClick={() => scrollToSection("presence")}
              className="font-mono text-xs tracking-[0.15em] uppercase text-pragti-bg/50 hover:text-pragti-bg transition-colors duration-300 text-left"
            >
              About
            </button>
            <button
              type="button"
              onClick={() => scrollToSection("roles")}
              className="font-mono text-xs tracking-[0.15em] uppercase text-pragti-bg/50 hover:text-pragti-bg transition-colors duration-300 text-left"
            >
              Who it helps
            </button>
            <button
              type="button"
              onClick={() => scrollToSection("waitlist", { focusEmail: true })}
              className="font-mono text-xs tracking-[0.15em] uppercase text-pragti-bg/50 hover:text-pragti-bg transition-colors duration-300 text-left"
            >
              Join waitlist
            </button>
            <Link
              to="/privacy"
              className="font-mono text-xs tracking-[0.15em] uppercase text-pragti-bg/50 hover:text-pragti-bg transition-colors duration-300"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="font-mono text-xs tracking-[0.15em] uppercase text-pragti-bg/50 hover:text-pragti-bg transition-colors duration-300"
            >
              Terms
            </Link>
            <a
              href="mailto:support@pragti.ai"
              className="font-mono text-xs tracking-[0.15em] uppercase text-pragti-bg/50 hover:text-pragti-bg transition-colors duration-300"
            >
              support@pragti.ai
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-16 pt-8 border-t border-pragti-bg/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
        >
          <p
            className="font-mono text-[11px] tracking-wide text-pragti-bg/30"
            data-testid="footer-copyright"
          >
            &copy; {new Date().getFullYear()} pragti. All rights reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  );
}
